//Can be use to style individual menu items
//[data-title="{title}"]
const getDataTitleTag = (title: string) => {
    title = (title ?? "").toLowerUnderscoreCase();

    return {
        "data-title": title
    };
}

export default getDataTitleTag;